import { render, staticRenderFns } from "./PlanView.vue?vue&type=template&id=2b415d9f&"
import script from "./PlanView.vue?vue&type=script&lang=js&"
export * from "./PlanView.vue?vue&type=script&lang=js&"
import style0 from "./PlanView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports